/** Monetary presentation metadata; never infer classifications or historical rates. */
export type ProcessingItem = {
  id?: number; name?: string | null;
  charge_type?: string; chargeType?: string;
  quantity?: number; weight_ton?: string | number; weightTon?: number;
  row_number?: number; rowNumber?: number;
  shape_id?: number | null; shapeId?: number | null;
  shape_name?: string | null; shapeName?: string | null;
  shape_number?: string | null; shapeNumber?: string | null;
  processing?: string | number;
  processing_exact?: string | number; processingExact?: number;
  processing_rate?: string | number | null; processingRate?: number | null;
  billing_quantity?: string | number; billingQuantity?: number;
  processing_missing?: boolean; processingMissing?: boolean;
};

export const preciseNumber = (value: number, minimumFractionDigits = 0) => value.toLocaleString("en-US", {
  minimumFractionDigits, maximumFractionDigits: 12,
  ...(value !== 0 && Math.abs(value) < 1e-12 ? { notation: "scientific" as const } : {}),
});

export function processingRows(items: ProcessingItem[] | undefined) {
  return (items || []).filter(item => ["cut", "bend", "unit"].includes(item.charge_type ?? item.chargeType ?? ""))
    .map(item => {
      const charge = item.charge_type ?? item.chargeType!;
      const quantity = item.billing_quantity ?? item.billingQuantity ?? (charge === "unit" ? item.quantity : item.weight_ton ?? item.weightTon);
      const rate = item.processing_rate ?? item.processingRate;
      const exact = item.processing_exact ?? item.processingExact;
      const amount = item.processing;
      return { item, charge, quantity: quantity == null ? null : Number(quantity),
        rate: rate == null ? null : Number(rate), amount: amount == null ? null : Number(amount),
        exact: exact == null ? null : Number(exact), missing: Boolean(item.processing_missing ?? item.processingMissing) };
    });
}
